import React, { useContext, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '/@/app/AppContext';
import { ScrollContext } from '/@/app/AppLayout';
import { Container, Box, Button, Link } from '@mui/material';
import { StepInfoBlock } from '/@/app/components/StepInfoBlock';
import { useApi } from '/@/app/Api';

export const NextView = () => {
const { t,i18n } = useTranslation();
const {restoreScroll}=useContext(ScrollContext);
    const { help } = useContext(AppContext).bootstrapData;
    const { download } = useApi();
    const containerRef = useRef(null);
restoreScroll();

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const handler = (e) => {
            const a = e.target.closest('a');
            if (!a) return;

            const href = a.getAttribute('href');
            if (!href) return;

            if (href.startsWith('/cabinet/exports/')) {
                e.preventDefault();

                const target = a.getAttribute('target');
                const isBlank = target === '_blank';

                download(href.slice(1), {mode:'full'}, { target: isBlank ? '_blank' : undefined, api_url:'v2', disable:a});
            }
        };

        el.addEventListener('click', handler);
        return () => el.removeEventListener('click', handler);
    }, [download]);

    return (
        <Container maxWidth="sm">
            <Box sx={{ pr: 1 }}>
                <div ref={containerRef} dangerouslySetInnerHTML={{ __html: help.texts['next-instruction-'+i18n.language] }} />
                <Box sx={{textAlign: "center", mt: 2 }}>
                    <Button variant="contained" component={Link} target="_blank" href="https://nestarenie.ru/vrachi.html">
                        {t("Консультация врача")}
                    </Button>
                </Box>
            </Box>

            <StepInfoBlock text={help.texts['next-footer-'+i18n.language]} />
        </Container>
    );
};
